export default {
	DB_HYDRATE_INSPECTION_FORM: 'DB_HYDRATE_INSPECTION_FORM',
	DB_CLEAR_SAFETY_INSPECTION_FORMS: 'DB_CLEAR_SAFETY_INSPECTION_FORMS',
	DB_UPDATE_TITLE: 'DB_UPDATE_TITLE',
	DB_UPDATE_INFO_FIELD: 'DB_UPDATE_INFO_FIELD',
	DB_UPDATE_OBSERVATIONS_FIELDS: 'DB_UPDATE_OBSERVATIONS_FIELDS',
	DB_UPDATE_UNSAFE_ACTS_PROCEDURE_DEVIATIONS_FIELD: 'DB_UPDATE_UNSAFE_ACTS_PROCEDURE_DEVIATIONS_FIELD',
	DB_UPDATE_ADDITIONAL_ACT_PROCEDURE: 'DB_UPDATE_ADDITIONAL_ACT_PROCEDURE',
	DB_UPDATE_COMMENTS: 'DB_UPDATE_COMMENTS',
	DB_UPDATE_VIOLATIONS_FIELD: 'DB_UPDATE_VIOLATIONS_FIELD'
};
